export default "__VITE_ASSET__BBOgLEzZ__"